import React from "react";

const Footer = () => {
  return <div className="h-[5vh]"></div>;
};

export default Footer;
